import service from '@/utils/server';

const modName = '/mdlzsct/receipt/';
//分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//重推
export const rePush = data => {
  return service({
    url: modName + 'rePush',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderReceiptLog/api/index.js